import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import {
  BannerTypes,
  PitchCardTypeEnum,
  WelcomeVideos
} from '@App/common/enums';
import { ScreenSizeService } from '@Shared/services';
import { StorageService } from '@Shared/services';
import { AppSettings } from '@Shared/app.settings';
import {
  BannerConfig,
  HowCardConfig,
  IntroPageConfig,
  VideoInfo,
  WhatCardConfig,
  WhyCardConfig
} from '@App/common/interfaces';

@Injectable({ providedIn: 'root' })
export class LandingPageService {

  constructor(
    private storageService: StorageService,
    @Inject(PLATFORM_ID) private platformId: any
  ) {}

  static easeInOutCubic(
    currentTime: number,
    startValue: number,
    changeInValue: number,
    duration: number
  ) {
    const time = currentTime / duration - 1;
    const timeCubic = time * time * time;
    return changeInValue * (timeCubic + 1) + startValue;
  }

  smoothVerticalScrolling(scrollTo, duration, x?) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const scrollFrom = window.scrollY || window.pageYOffset || 0;

    const scrollDiff = scrollTo - scrollFrom;

    let currentTime = 0;
    const increment = 20;
    const url = document.location.pathname;

    (function animateScroll() {
      currentTime += increment;
      const newScrollPos = LandingPageService.easeInOutCubic(
        currentTime,
        scrollFrom,
        scrollDiff,
        duration
      );
      if (currentTime > duration || url !== document.location.pathname) {
        return;
      }
      window.scrollTo(x !== null ? x : 0, newScrollPos);

      setTimeout(animateScroll, increment);
    })();
  }

  getBannerConfig(landing: number): BannerConfig {
    switch (landing) {
      case BannerTypes.MainBanner:
        return {
          type: BannerTypes.MainBanner,
          whiteTitle:
            'Digital Resume PitchCards: The perfect networking and referral tool',
          mobileWhiteTitle:
            'Digital Resume PitchCards: The perfect networking and referral tool',
          gradientTitle: '',
          isGradientLast: false,
          isMobileGradientLast: false,
          isSinglePCImage:
            './assets/images/welcome/banners-imgs/carousel-3.png',
          subTitleList: [
            '<strong class="font-weight-800">Gain Exposure.</strong> Effortlessly create & share your 59-second elevator pitch with the world.',
            '<strong class="font-weight-800">10x Your Referrals.</strong> Anyone can refer & introduce you in just 5-7 seconds.',
            '<strong class="font-weight-800">Expand Your Network.</strong> Connect with others in the Pitch59 community.'
          ],
          createBtnText: 'Create PitchCard',
          secondaryBtnText: 'Watch Demo',
          isSecondaryVideoButton: true,
          buttonDescr: 'Takes less than 10 minutes!',
          createBtnLink: '/pricing',
          secondaryLink: 'https://calendly.com/jeffpitch59/meeting'
        };
      case BannerTypes.ResumeBanner:
        return {
          type: BannerTypes.ResumeBanner,
          whiteTitle:
            'Digital Resume PitchCards: The perfect networking and referral tool',
          mobileWhiteTitle:
            'Digital Resume PitchCards: The perfect networking and referral tool',
          gradientTitle: '',
          isGradientLast: true,
          isMobileGradientLast: true,
          isSinglePCImage: true,
          subTitleList: [
            'Stand out from other applicants and let employers get to know you.',
            'Make it easy for your contacts to refer and introduce you to employers.',
            'Grow your network with everyone in the Pitch59 community.'
          ],
          createBtnText: 'Create Resume PitchCard',
          secondaryBtnText: 'Watch Demo',
          isSecondaryVideoButton: true,
          imgBannerUrl: './assets/images/welcome/banners-imgs/carousel-1.png',
          createBtnLink: '/pricing',
          secondaryLink: '/search?types=job'
        };
      default:
        break;
    }
  }

  getPartnersImageList(isMobile: boolean) {
    return [
      {
        url: './assets/images/partners/icon-bni.svg',
        title: 'BNI'
      },
      {
        url: './assets/images/partners/icon-exit.svg',
        title: 'EXIT'
      },
      {
        url: './assets/images/partners/icon-nr.svg',
        title: 'NR'
      },
      {
        url: './assets/images/partners/icon-sales-x.svg',
        title: 'SX'
      },
      {
        url: './assets/images/partners/icon-tr.svg',
        title: 'TR'
      },
      {
        url: './assets/images/partners/icon-tribe.svg',
        title: 'TRIBE'
      },
      {
        url: './assets/images/partners/icon-usc.svg',
        title: 'USC'
      },
      {
        url: './assets/images/partners/icon-uvu.svg',
        title: 'UVU'
      },
      {
        url: './assets/images/partners/LeadingRELogo.png',
        title: 'UVU'
      },{
        url: './assets/images/partners/NebraskaRealtyLogo.png',
        title: 'UVU'
      },{
        url: './assets/images/partners/OneAmericaFinancialLogo.png',
        title: 'UVU'
      },{
        url: './assets/images/partners/OnePacificLogo.png',
        title: 'UVU'
      },{
        url: './assets/images/partners/ResortAllianceLogo.png',
        title: 'UVU'
      },
      {
        url: './assets/images/partners/image-rnaor.webp',
        title: 'RNAOR'
      }
    ];
  }

  setLastPageUrl() {
    if (isPlatformBrowser(this.platformId)) {
      this.storageService.setSession(
        AppSettings.LAST_PAGE_URL,
        window.location.pathname
      );
    }
  }
}
